import React from 'react';
import { connect } from 'react-redux';
import { validator } from '../../../utils';
import * as authActions from '../../../redux/auth/actions';
import Spin from '../../../components/loading';

class GetMobileNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNumber: this.props.mobileNumber || '',
      errorFlag: false
    }
  }

  handleInputChange = event => {
    this.setState({ errorFlag: false, mobileNumber: event.target.value });
  };

  onSubmit = event => {
    let { mobileNumber } = this.state;
    event.preventDefault();
    if (validator.isMobileNumber(mobileNumber)) {
      this.props.sendMobileNumber(mobileNumber).then(() => {
        this.props.setMobileNumber(mobileNumber);
        this.props.changeStep(2)
      });
    }
    else {
      this.setState({ errorFlag: true, errorMessage: locales('labels.mobileNumberFormatInvalid') });
    }
  };

  render() {
    let { mobileNumber, errorFlag, errorMessage } = this.state;
    let { error, loading, message, failed } = this.props;
    return (
      <>
        <Spin spinning={loading}>
          <h3 className="text-white d-flex justify-content-start font-italic">
            {locales("titles.restorePassword")}
          </h3>
          {error && (
            <div className="alert alert-danger">
              {locales("messages.server.error")}
            </div>
          )}
          {failed && <div className="alert alert-danger">{message}</div>}
          <div className='col-12 d-flex justify-content-center align-items-center flex-column'>
            <input
              value={mobileNumber}
              name="password"
              onChange={event => this.handleInputChange(event)}
              className={`${errorFlag ? 'border border-danger' : ''} form-control my-2 p-1`}
              type="text"
              placeholder={locales("labels.enterPhoneNumber")}
            />
            <div className='text-danger'>
              {errorFlag && errorMessage}
            </div>
            <div className="p-0 d-flex justify-content-center col-12 align-items-center">
              <button
                type="button"
                onClick={event => this.onSubmit(event)}
                className="w-50 btn btn-primary mt-4">
                {locales("labels.sendVerificationCode")}
              </button>
            </div>
          </div>
        </Spin>
      </>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    error: state.authReducer.forgetPasswordError,
    failed: state.authReducer.forgetPasswordFailed,
    loading: state.authReducer.forgetPasswordLoading,
    message: state.authReducer.forgetPasswordMessage
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendMobileNumber: mobileNumber => dispatch(authActions.sendMobileNumber(mobileNumber))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(GetMobileNumber);